<script>
import {mapGetters} from "vuex";
import moment from "moment";
import {getActiveOrderDataIndex, getOrderTotalAmount} from "@/views/purchase/_store/getters";
import {removeOrderDataByIndex, setReturnDate} from "@/views/purchase/_store/actions";
import _, { get } from "lodash";
import { useDestinationStore } from "../../../store/destinationStore";
import { useOrderStore } from "../../../store/orderStore";
import { useShipmentStore } from "../../../store/shipmentStore";
import { useDiscountStore } from "../../../store/discountStore";
import { usePeriodStore } from "../../../store/periodStore";
import { usePlanStore } from "../../../store/planStore";
import { computed } from "vue";
import { useDeviceStore } from "../../../store/deviceStore";

export default {
    name: "PurchaseCard",
    
    setup() {
        const destinationStore = useDestinationStore();
        const orderStore = useOrderStore();
        const shipmentStore = useShipmentStore();
        const discountStore = useDiscountStore();
        const periodStore = usePeriodStore();
        const planStore = usePlanStore();
        const deviceStore = useDeviceStore();

        const isCardEmpty = computed(() => {
            return !destinationStore.selectedDestinations[0]?.id;
        });

        function getFormatDate(date) {
            return date ? moment(date).format('MM/DD/YYYY') : 'Not selected';
        };

        function getDestinationName(destination) {
            return destination?.name || 'Not selected';
        };

        function getPeriodString(startDate, endDate) {
            if (!startDate || !endDate) return 'Not selected';
            return `${getFormatDate(startDate)} - ${getFormatDate(endDate)}`;
        };

        function getPlanName(plan) {
            return plan?.name || 'Not selected';
        };

        function getShipmentTypeText(type) {
            if (type === 'delivery') return 'Delivery';
            if (type === 'pickup') return 'Pickup';
            return 'Not selected';
        };

        function getPickupLocationName(location) {
            return location?.name || 'Not selected';
        };

        return { 
            destinationStore, 
            orderStore, 
            shipmentStore,
            isCardEmpty,
            discountStore,
            periodStore,
            planStore,
            deviceStore,
            getFormatDate,
            getPeriodString,
            getDestinationName,
            getPlanName,
            getShipmentTypeText,
            getPickupLocationName,
        };
    },

    computed: {
        // moment() {
        //     return moment
        // },
        // ...mapGetters({
        //     orderData: 'purchase/getOrderData',
        //     activeOrderDataIndex: 'purchase/getActiveOrderDataIndex',
        //     orderSubtotalAmount: 'purchase/getOrderSubtotalAmount',

        //     selectedCountry: 'purchase/getSelectedCountry',
        //     startDate: 'purchase/getStartDate',
        //     numberOfDays: 'purchase/getNumberOfDays',
        //     numberOfDevices: 'purchase/getNumberOfDevices',
        //     planType: 'purchase/getPlanType',
        //     selectedPlan: 'purchase/getSelectedPlan',
        //     shipmentType: 'purchase/getShipmentType',
        //     deliveryPrice: 'purchase/getDeliveryPrice',
        //     couponDiscountAmount: 'purchase/getCouponDiscountAmount',
        //     giftCardDiscountAmount: 'purchase/getGiftCardDiscount',
        //     insuranceAmount: 'purchase/getInsuranceAmount',
        //     orderTotalAmount: 'purchase/getOrderTotalAmount',
        //     selectedDeviceExtraCharge: 'purchase/getSelectedDeviceExtraCharge',
        //     totalAmountForDeviceExtraCharge: 'purchase/getTotalAmountForDeviceExtraCharge',
        // }),
        // deliveryPriceText() {
        //     let orderData = this.orderData[this.activeOrderDataIndex];
        //     let text = '$0';
        //     let totalPrice = this.orderSubtotalAmount - this.couponDiscountAmount;

        //     if (orderData.shipment_type === 'delivery' && orderData.delivery_type_id) {
        //         text = '$' + orderData.delivery_type_charges;

        //         if (totalPrice >= 99 && orderData.delivery_type_id === 2) {
        //             text = 'FREE';
        //         }
        //     }

        //     return text;
        // },
    },

    methods: {
        // isCardEmpty(i) {
        //     if (!!this.orderData[i].plan_id) return false;

        //     return true;
        // },
        editOrder(i) {
            this.$store.dispatch('purchase/setActiveOrderDataIndex', i);

            let orders = _.cloneDeep(this.orderData);
            let emptyOrderIndex = orders.findIndex((order) => !order.plan_id);

            if (emptyOrderIndex > -1) {
                orders.splice(emptyOrderIndex, 1);
            }

            this.$store.dispatch('purchase/setOrderData', orders);
        },
        removeOrder(i) {
            this.$store.dispatch('purchase/removeOrderDataByIndex', i);
        },
        getEndDate(order) {
            if (order.plan_type === 'day') {
                return moment(order.start_date).add(order.number_of_days - 1, 'days').format('MM/DD/YYYY');
            }

            if (order.plan_type === 'month') {
                return moment(order.start_date).add(order.number_of_days, 'months').format('MM/DD/YYYY');
            }
        },
        returnDate(i) {
            let numToAdd = 5;
            let orderData = _.cloneDeep(this.orderData[i]);
            if(orderData && orderData.start_date) {
                let endDate = moment(orderData.start_date).add(orderData.number_of_days, 'days');

                if (endDate) {
                    endDate.add(numToAdd, 'days');

                    if (endDate.day() === 0) {
                        endDate.add(1, 'days');
                    } else if (endDate.day() === 6) {
                        endDate.add(2, 'days');
                    }
                }

                endDate = endDate.format('MM/DD/YYYY');

                this.$store.dispatch('purchase/setReturnDate', endDate);

                return endDate;
            }
        },
    }
}
</script>

<template>
    <div class="purchase-card">
        <div
            class="purchase-card__item"
        >
            <template v-if="isCardEmpty">
                <h1 class="empty-text">
                    {{ $t('purchase-rent-page.purchaseCard.emptyCardText') }}
                </h1>
            </template>
            <template v-if="!isCardEmpty">
                <div class="purchase-card__item--head">
                    <div class="left">
                        <h2 class="inline-block w-ful mb-6 text-xl font-bold">{{ $t('purchase-rent-page.purchaseCard.title') }}</h2>
                        <span class="inline-block w-full">Total amount</span>
                        <span class="text-sky-400 text-3xl font-medium">${{ orderStore.totalAmount }}</span>
                    </div>
                    <div class="right">
                        <img src="@/assets/png/pro-2.png" />
                    </div>
                </div>
                <div class="purchase-card__item--body">
                    <template v-for="(destination, i) in destinationStore.selectedDestinations" :key="i">
                        <div class="info">
                            <span>{{ $t('purchase-rent-page.purchaseCard.destination') }}</span>
                            <span>{{ getDestinationName(destination) }}</span>
                        </div>
                        <div class="info">
                            <span>{{ $t('purchase-rent-page.purchaseCard.days') }}</span>
                            <span>{{ periodStore.getPeriodDays(i) }}</span>
                        </div>
                        <div class="info">
                            <span>{{ $t('purchase-rent-page.purchaseCard.period') }}</span>
                            <span>{{ getPeriodString(periodStore.periods[i].startDate, periodStore.periods[i].endDate) }}</span>
                        </div>
                        <div class="info">
                            <span>{{ $t('purchase-rent-page.purchaseCard.plan') }}</span>
                            <span>{{ getPlanName(planStore.plans[i]) }}</span>
                        </div>
                        <div class="br mb-4"></div>
                    </template>
                    <div class="info">
                        <span>{{ $t('purchase-rent-page.purchaseCard.deviceQuantity') }}</span>
                        <span>{{ deviceStore.device_quantity || 'Not selected' }}</span>
                    </div>
                    <div class="info">
                        <span>{{ $t('purchase-rent-page.purchaseCard.deviceType') }}</span>
                        <span>{{ deviceStore.selectedDevice?.name || 'Not selected' }}</span>
                    </div>
                    <div class="info">
                        <span>{{ $t('purchase-rent-page.purchaseCard.subtotal') }}</span>
                        <span>${{ orderStore.subtotalAmount }}</span>
                    </div>
                    <div class="info">
                        <span>{{ $t('purchase-rent-page.purchaseCard.shippingMethod') }}</span>
                        <span class="capitalize">{{ getShipmentTypeText(shipmentStore.shipment_type) }}</span>
                    </div>
                    <template v-if="shipmentStore.shipment_type === 'pickup'">
                        <div class="info">
                            <span>{{ $t('purchase-rent-page.purchaseCard.pickupLocation') }}</span>
                            <span>{{ getPickupLocationName(shipmentStore.selectedPickupLocation) }}</span>
                        </div>
                        <div class="info">
                            <span>{{ $t('purchase-rent-page.purchaseCard.pickupDate') }}</span>
                            <span>{{ getFormatDate(shipmentStore.pickup_date) }}</span>
                        </div>
                    </template>
                    <template v-if="shipmentStore.shipment_type === 'delivery'">
                        <div class="info">
                            <span>{{ $t('purchase-rent-page.purchaseCard.shippingPrice') }}</span>
                            <span>${{ shipmentStore.deliveryPrice }}</span>
                        </div>
                    </template>
                    <div class="info">
                        <span>{{ $t('purchase-rent-page.purchaseCard.insurance') }}</span>
                        <span>${{ orderStore.insurancePrice }}</span>
                    </div>
                    <div class="info">
                        <span>{{ $t('purchase-rent-page.purchaseCard.deviceExtraCharge') }}</span>
                        <span>${{ deviceStore.totalExtraCharge }}</span>
                    </div>
                    <div class="info">
                        <span>{{ $t('purchase-rent-page.purchaseCard.promoCodeDiscount') }}</span>
                        <span>${{ discountStore.couponDiscountAmount }}</span>
                    </div>
                    <div class="info">
                        <span>{{ $t('purchase-rent-page.purchaseCard.giftCardDiscount') }}</span>
                        <span>${{ discountStore.giftCard?.amount || 0 }}</span>
                    </div>
                    <div class="br"></div>
                </div>
                <div class="purchase-card__item--foot">
                    <div class="total">
                        <span>{{ $t('purchase-rent-page.purchaseCard.total') }}</span>
                        <span>${{ orderStore.totalAmount }}</span>
                    </div>
                    <!-- <div
                        v-if="order.plan_id"
                        class="alert"
                    >
                        {{ $t('purchase-rent-page.purchaseCard.alert').replace("$return_date", orderData[i].return_date).replace("$return_date", orderData[i].return_date) }}
                    </div> -->
                </div>
            </template>
        </div>
    </div>
</template>

<style lang="scss">
    .purchase-card {
        &__item {
            width: 100%;
            padding: 1.5rem;
            border-radius: 8px;
            border: 2px solid #FE9634;
            background: #ffffff;
            margin-bottom: 1.5rem;

            .empty-text {
                font-weight: 400;
                font-style: italic;
            }

            &--head {
                display: flex;
                justify-content: space-between;
                border-bottom: 2px solid #7DD3FC;
                padding-bottom: 1rem;
                margin-bottom: 1rem;

                .left {
                    h1 {
                        font-size: 1rem;
                        font-weight: 500;
                        color: #000000;
                        margin-bottom: .5rem;
                    }

                    p {
                        font-size: 1rem;
                        font-weight: 400;
                        color: #000000;
                        margin-bottom: .5rem;
                    }
                }

                .right {
                    width: 120px;
                    height: 120px;
                }
            }

            &--body {

                .info {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 1rem;

                    span {
                        font-size: 1rem;
                        color: #000000;
                    }
                }

                .br {
                    border: none;
                    border-bottom: 2px solid #7DD3FC;
                }
            }

            &--foot {
                .total {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 1rem;

                    span {
                        font-size: 24px;
                        color: #7DD3FC;
                        font-weight: 500;
                    }
                }

                .alert {
                    font-size: 12px;
                    color: #CA0000;
                    font-weight: 400;
                    margin-bottom: 1rem;
                }
            }

            &-edit-btn {
                display: none;
                border-radius: 8px;
                border: 2px solid #7DD3FC;
                color: #7DD3FC;
                width: 100%;
                padding: .25rem .5rem;
                margin-bottom: 1rem;

                &:hover {
                    background: #7DD3FC;
                    color: #ffffff;
                }
            }

            &-remove-btn {
                display: none;
                border-radius: 8px;
                border: 2px solid #FE9634;
                color: #FE9634;
                width: 100%;
                padding: .25rem .5rem;

                &:hover {
                    background: #FE9634;
                    color: #ffffff;
                }
            }

            &.short {
                margin-bottom: 1.5rem;

                .purchase-card__item--head {
                    border-bottom: none;
                    margin-bottom: 0;
                    padding-bottom: 0;

                    .right {
                        height: 100px;

                        img {
                            height: 95px;
                            display: none;
                        }

                        &-edit-btn {
                            display: block;
                        }

                        &-remove-btn {
                            display: block;
                        }
                    }
                }
                .purchase-card__item--body {
                    display: none;
                }
                .purchase-card__item--foot {
                    display: none;
                }
                .purchase-card__item-edit-btn {
                    display: block;
                }
                .purchase-card__item-remove-btn {
                    display: block;
                }
            }
        }
    }
</style>